export default __webpack_public_path__ + "static/media/Padron_ExecutiveClosed.60754e7b.jpg";